module.exports = __webpack_public_path__ + "static/img/3areaB_6.3601b06.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_6.png
// module id = 1178
// module chunks = 1